import { environment } from '../../../../../../environments/environment';
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { Subject, Subscription, firstValueFrom } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { DeviceDetectionService } from '../../../../../shared/services/device-detection.service';
import { AuthService } from '../../../../../services/auth.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { formularioService } from '../../../../colaborador/services/formulario.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


declare var L: any;

@Component({
  selector: 'app-servicos',
  standalone: false,
  templateUrl: './servicos.component.html',
  styleUrl: './servicos.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicosComponent implements OnInit {
  rotacoesMiniatura: { [url: string]: number } = {};
  getRotacaoMiniatura(url: string): number {
    const key = this.getFotoRotacaoKey(url);
    if (this.rotacoesMiniatura[key] !== undefined) return this.rotacoesMiniatura[key];
    const rotacaoSalva = localStorage.getItem(key);
    return rotacaoSalva ? parseInt(rotacaoSalva, 10) : 0;
  }

  girarMiniatura(url: string, direcao: 'esquerda' | 'direita'): void {
    const key = this.getFotoRotacaoKey(url);
    let rot = this.getRotacaoMiniatura(url);
    rot += direcao === 'esquerda' ? -90 : 90;
    rot = ((rot % 360) + 360) % 360;
    this.rotacoesMiniatura[key] = rot;
    // Salva automaticamente ao girar
    localStorage.setItem(key, rot.toString());
    // Força detecção de mudança
    this.cdr.markForCheck();
  }

  // Removido: salvarRotacaoMiniatura (não é mais necessário)
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
  }

  // Método para otimizar o *ngFor evitando recriar DOM desnecessariamente
  trackById(index: number, item: any): string {
    return item.id || index;
  }

  // Método para alternar filtros com detecção de mudança
  toggleFiltros(): void {
    this.showFiltros = !this.showFiltros;
    this.cdr.markForCheck();
  }

  formatNumeroOS(servico: any): string {
    if (!servico) return '-';
    const candidato = servico.numeroOS || servico.numeroOs || servico.numeroOrdem || servico.numero || servico.ordemNumero || servico.numeroOrdemFormatado || servico.osNumero || servico.osNumero1 || servico.osNumero2 || servico.osNumero3;
    if (!candidato && candidato !== 0) return '-';
    const s = candidato.toString();

    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    // Pad para 4 dígitos (ex: 14 -> 0014)
    return s.padStart(4, '0');
  }

  getUsuarioDisplay(servico: any): string {
    if (!servico) return '-';
    return servico.analisadoPorNome || servico.nomeUsuario || servico.usuario?.nome || servico.usuario || servico.nome || '-';
  }

  getDataAnalise(servico: any): any {
    if (!servico) return null;
    return servico.dataHoraInicioAnalise || servico.dataAnaliseInicio || servico.dataInicioAnalise || servico.dataAnaliseAtendimento || servico.dataAnaliseUsuario || servico.dataAnaliseHora || null;
  }
  // Filtros
  filtroUsuarioId: string = '';
  // By default leave date filters empty so the user can choose the period manually
  filtroDataInicio: string = '';
  filtroDataFim: string = '';
    private readonly LS_KEY_DATA_INICIO = 'servicos_filtroDataInicio';
    private readonly LS_KEY_DATA_FIM = 'servicos_filtroDataFim';
    // LocalStorage keys for pagination persistence
    private readonly LS_KEY_PAGINA = 'servicos_paginaAtual';
    private readonly LS_KEY_TAMANHO = 'servicos_tamanhoPagina';
    private readonly TODOS_PAGE_SIZE = 200;
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  // Filtros adicionais (como em ordem-servico)
  showFiltros: boolean = false;
  filtroStatus: string = '';
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string = '';
  filtroNomeConsumidor: string = '';
  // novos campos solicitados
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  

  servicos: any[] = [];
  servicosFiltrados: any[] = [];
  erro: string | null = null;

  // Referência ao Math para uso no template
  Math = Math;
  servicoDetalhes: any = null;
  mostrarModalFoto = false;
  fotoSelecionada = '';

  // Ângulo de rotação da foto ampliada
  rotacaoFoto = 0;

  // Paginação
  paginaAtual = 1;
  tamanhoPagina = 50;
  mostrarTodosRegistros = false;
  totalItens = 0;
  totalPaginas = 0;
  filtroNumero: string = '';
  // filtroNumeroVistoria: usado apenas para o campo 'Nº Vistoria' (local filtering por numeroOS)
  filtroNumeroVistoria: string = '';
  // Subject para debounce do campo Nº Vistoria (busca direto na API)
  private numeroVistoriaSubject: Subject<string> = new Subject<string>();
  private numeroVistoriaSub?: Subscription;
  
  @ViewChild('conteudoModal', { static: false }) conteudoModal!: ElementRef;
  htmlCompletoParaExportar: string = '';

  // Retorna o total de registros atualmente filtrados (útil para exibição no template)
  get totalRegistros(): number | null {
    return this.totalItens > 0 ? this.totalItens : null;
  }

  constructor(
    private usuarioService: UsuarioService,
    private servicoService: ServicoService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private formularioService: formularioService,
    protected authService: AuthService,
    private router: Router,
    private ngZone: NgZone,
    private deviceService: DeviceDetectionService
  ) { }

  get isSuperAdministrador(): boolean {
    try {
      return this.authService.isSuperAdmin();
    } catch (e) {
      return false;
    }
  }

  ngOnInit(): void {
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (colaboradores) => {
        this.usuariosFiltro = colaboradores
          .map((u: any) => ({ usuarioId: u.usuarioId, nome: u.nome }))
          .filter(u => !!u.usuarioId && !!u.nome);
      },
      error: () => {
        this.usuariosFiltro = [];
      }
    });

  // Restaurar filtro de período do localStorage, se existir
  const lsDataInicio = localStorage.getItem(this.LS_KEY_DATA_INICIO);
  const lsDataFim = localStorage.getItem(this.LS_KEY_DATA_FIM);
  this.filtroDataInicio = lsDataInicio || this.getDataSeteDiasAtrasInput();
  this.filtroDataFim = lsDataFim || this.getDataHojeInput();

  // Restaurar paginação persistida (página e tamanho)
  const lsPagina = localStorage.getItem(this.LS_KEY_PAGINA);
  const lsTamanho = localStorage.getItem(this.LS_KEY_TAMANHO);
  if (lsPagina) {
    const p = Number(lsPagina);
    if (!isNaN(p) && p >= 1) this.paginaAtual = p;
  }
  if (lsTamanho) {
    const t = Number(lsTamanho);
    if (!isNaN(t)) {
      if (t === -1) {
        this.tamanhoPagina = -1;
        this.mostrarTodosRegistros = true;
      } else if (t > 0) {
        this.tamanhoPagina = t;
      }
    }
  }

  // Carrega usando a paginação restaurada (preserva o valor restaurado de paginaAtual)
  this.aplicarFiltro(true);

  // Inscrever no subject para buscas debounced por Nº Vistoria
  this.numeroVistoriaSub = this.numeroVistoriaSubject.pipe(
    debounceTime(350),
    distinctUntilChanged()
  ).subscribe(value => {
    // se campo vazio, reaplica o filtro normal para recarregar lista
    if (!value || value.toString().trim() === '') {
      this.aplicarFiltro();
      return;
    }
    // chamar API buscando por numeroOS
    this.buscarPorNumeroOS(value.toString().trim());
  });
  }

  ngOnDestroy(): void {
    if (this.numeroVistoriaSub) {
      this.numeroVistoriaSub.unsubscribe();
    }
  }

  onNumeroVistoriaInputChanged(value: string): void {
    // quando o usuário digita, emitimos no subject para debounce
    this.numeroVistoriaSubject.next(value);
  }

  private buscarPorNumeroOS(numero: string): void {
    this.spinner.show();
    this.erro = null;

    const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
    const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

    // Envia o filtro numeroOS para a API (o ServicoService já define variantes de nomes)
    this.servicoService.obterTodos(
      dataInicio,
      dataFim,
      1,
      this.tamanhoPagina,
      '', // status vazio para não filtrar por status aqui
      this.filtroNomeConsumidor,
      this.filtroCpf,
      this.filtroCnpj,
      this.filtroMatricula,
      this.filtroCep,
      this.filtroLogradouro,
      this.filtroBairro,
      this.filtroCidade,
      this.filtroEstado,
      undefined, // numero (logradouro)
      numero, // numeroOS
      undefined // statusOS
    ).subscribe({
      next: (response) => {
        this.processarDadosPaginados(response);
        this.atualizarInformacoesPaginacao(response);
        // aplicar filtros locais adicionais (nome/matricula/status) sobre os resultados
        this.aplicarFiltrosLocais();
        this.spinner.hide();
      },
      error: (err) => {
        this.servicos = [];
        this.servicosFiltrados = [];
        this.erro = 'Erro ao buscar pelo Nº Vistoria.';
        this.spinner.hide();
      }
    });
  }

  aplicarFiltro(preservePage: boolean = false): void {
    this.spinner.show();
    this.erro = null;
    // Reset para primeira página somente quando não estamos preservando a paginação
    if (!preservePage) {
      this.paginaAtual = 1; // Reset para primeira página
    }
    this.showFiltros = false; // Fecha a parte do filtro ao aplicar

    // Persistir filtro de período no localStorage
    if (this.filtroDataInicio) {
      localStorage.setItem(this.LS_KEY_DATA_INICIO, this.filtroDataInicio);
    }
    if (this.filtroDataFim) {
      localStorage.setItem(this.LS_KEY_DATA_FIM, this.filtroDataFim);
    }

    // Formatar datas para ISO completo (yyyy-MM-ddTHH:mm:ss)
    const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
    const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;


    // Para "Validado" ou "Invalido", envia como Status; para os demais, como StatusOS
    let status = '';
    let statusOS = '';
    if (this.filtroStatus === 'Validado' || this.filtroStatus === 'Invalido') {
      status = this.filtroStatus;
    } else {
      statusOS = this.filtroStatus || '';
    }

  const usarTodos = this.tamanhoPagina === -1;
  this.mostrarTodosRegistros = usarTodos;

    if (!this.filtroUsuarioId) {
      if (usarTodos) {
        this.buscarTodosRegistros(status, statusOS, dataInicio, dataFim)
          .then(({ registros, total }: { registros: any[]; total: number }) => {
            this.prepararRegistrosParaApresentacao(registros, total);
            this.aplicarFiltrosLocais();
            this.spinner.hide();
          })
          .catch((err: any) => {
            console.error('Erro ao buscar registros completos:', err);
            this.servicos = [];
            this.servicosFiltrados = [];
            this.totalItens = 0;
            this.totalPaginas = 1;
            this.erro = 'Erro ao buscar registros.';
            this.spinner.hide();
          });
        return;
      }
      this.servicoService.obterTodos(
        dataInicio,
        dataFim,
        this.paginaAtual,
        this.tamanhoPagina,
        status, // <-- send as 'Status' param to API
        this.filtroNomeConsumidor,
        this.filtroCpf,
        this.filtroCnpj,
        this.filtroMatricula,
        this.filtroCep,
        this.filtroLogradouro,
        this.filtroBairro,
        this.filtroCidade,
        this.filtroEstado,
        this.filtroNumero,
        undefined, // numeroOS
        statusOS // statusOS
      ).subscribe({
        next: (response) => {
          // Processa a resposta do obterTodos (otimizado)
          this.processarDadosPaginados(response);
          this.atualizarInformacoesPaginacao(response);
          // aplica filtros adicionais localmente (status, numero ordem, matricula, nome)
          this.aplicarFiltrosLocais();
          this.spinner.hide();
        },
        error: (err) => {
          this.servicos = [];
          this.servicosFiltrados = [];
          this.erro = 'Erro ao buscar registros.';
          this.spinner.hide();
        }
      });
      return;
    }
    if (usarTodos) {
      this.buscarTodosRegistros(status, statusOS, dataInicio, dataFim, true)
        .then(({ registros, total }: { registros: any[]; total: number }) => {
          this.prepararRegistrosParaApresentacao(registros, total);
          this.aplicarFiltrosLocais();
          this.spinner.hide();
        })
  .catch((err: any) => {
          console.error('Erro ao buscar registros completos (usuario):', err);
          this.servicos = [];
          this.servicosFiltrados = [];
          this.totalItens = 0;
          this.totalPaginas = 1;
          this.erro = 'Erro ao buscar registros.';
          this.spinner.hide();
        });
      return;
    }
    this.servicoService.obterTodosRegistrosPorPeriodo(
      this.filtroUsuarioId,
      dataInicio,
      dataFim,
      Number(this.paginaAtual),
      Number(this.tamanhoPagina),
      status,
      this.filtroNomeConsumidor,
      this.filtroCpf,
      this.filtroCnpj,
      this.filtroMatricula,
      this.filtroCep,
      this.filtroLogradouro,
      this.filtroBairro,
      this.filtroCidade,
      this.filtroEstado,
      this.filtroNumero,
      undefined // do not send statusOS separately; API will use Status param
    ).subscribe({
      next: (response) => {
        // Processa a resposta do obterTodosRegistrosPorPeriodo
        this.processarDadosServicos(response);
        this.atualizarInformacoesPaginacao(response);
        // aplica filtros adicionais localmente (status, numero ordem, matricula, nome)
        this.aplicarFiltrosLocais();
        this.spinner.hide();
      },
      error: (err) => {
        this.servicos = [];
        this.servicosFiltrados = [];
        this.erro = 'Erro ao buscar registros.';
        this.spinner.hide();
      }
    });
  }

  onFiltroDataFimChange(): void {
    // If no end date selected, do nothing (user may be clearing the filter)
    if (!this.filtroDataFim) {
      return;
    }

    // Persistir filtro de período no localStorage ao alterar data fim
    localStorage.setItem(this.LS_KEY_DATA_FIM, this.filtroDataFim);

    // Allow the ngModel binding to settle, then apply the filter.
    setTimeout(() => {
      try {
        this.aplicarFiltro();
      } catch (e) {
        // swallow to avoid breaking UI; spinner/error handling is inside aplicarFiltro
        console.error('Erro ao aplicar filtro automaticamente por data fim', e);
      }
    }, 50);
  }

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    // Reset date filters to empty to let the user choose
    this.filtroDataInicio = '';
    this.filtroDataFim = '';
    this.tamanhoPagina = 50; // Reset page size to default
    this.paginaAtual = 1; // Reset to first page
    this.servicos = [];
    this.servicosFiltrados = [];
    this.erro = null;
    // reset filtros avancados
    this.showFiltros = false;
    this.filtroStatus = '';
    this.filtroNumeroOrdem = null;
    this.filtroMatricula = '';
    this.filtroNomeConsumidor = '';
    this.filtroCpf = '';
    this.filtroCnpj = '';
    this.filtroCep = '';
    this.filtroLogradouro = '';
    this.filtroBairro = '';
    this.filtroCidade = '';
    this.filtroEstado = '';
    this.filtroNumero = '';
    this.filtroNumeroVistoria = '';
  }

  aplicarFiltrosLocais(): void {
    if (!this.servicos || this.servicos.length === 0) {
      this.servicosFiltrados = [];
      return;
    }

    const statusFiltro = (this.filtroStatus || '').toString().trim().toLowerCase();
    const numOrdemFiltro = this.filtroNumeroOrdem;
    const matriculaFiltro = (this.filtroMatricula || '').toString().trim().toLowerCase();
    const nomeFiltro = (this.filtroNomeConsumidor || '').toString().trim().toLowerCase();
    const numeroFiltro = (this.filtroNumeroVistoria || '').toString().trim().toLowerCase();

    this.servicosFiltrados = this.servicos.filter(s => {
      // status
      if (statusFiltro) {
        // Check both 'status' and 'statusOS' (and effectiveStatus) so local filtering matches server behaviour
        const sStatus = (s.status || '').toString().toLowerCase();
        const sStatusOS = (s.statusOS || s.statusOs || s.status_os || '').toString().toLowerCase();
        const eff = (this.effectiveStatus(s) || '').toString().toLowerCase();
        if (!(sStatus.includes(statusFiltro) || sStatusOS.includes(statusFiltro) || eff.includes(statusFiltro))) return false;
      }

      // numero da ordem (aceita campo numeroOrdem, numeroOrdemFormatado ou ordemNumero)
      if (numOrdemFiltro !== null && numOrdemFiltro !== undefined && numOrdemFiltro !== 0) {
        const candidatos = [s.numeroOrdem, s.numeroOrdemFormatado, s.ordemNumero, s.numero];
        const encontrado = candidatos.some((c: any) => c !== undefined && c !== null && c.toString().indexOf(numOrdemFiltro.toString()) !== -1);
        if (!encontrado) return false;
      }

      // matricula
      if (matriculaFiltro) {
        const sMat = (s.matricula || s.matriculaConsumidor || s.matriculaUsuario || '').toString().toLowerCase();
        if (!sMat.includes(matriculaFiltro)) return false;
      }

      // nome consumidor
      if (nomeFiltro) {
        const sNome = (s.nomeConsumidor || s.nome || '').toString().toLowerCase();
        if (!sNome.includes(nomeFiltro)) return false;
      }

      // numero (Nº Vistoria) - comparar com varios campos incluindo numeroOS
      if (numeroFiltro) {
        const candidatosNumero = [
          s.numeroOS, s.numeroOs, s.numeroOrdemFormatado, s.numeroOrdem, s.numero, s.ordemNumero
        ];

        const numeroFiltroSemZeros = numeroFiltro.replace(/^0+/, '');

        const encontradoNumero = candidatosNumero.some((c: any) => {
          if (c === undefined || c === null) return false;
          const cs = c.toString().toLowerCase();
          // comparar tanto com zeros quanto sem zeros à esquerda
          if (cs.includes(numeroFiltro)) return true;
          if (cs.replace(/^0+/, '').includes(numeroFiltroSemZeros)) return true;
          return false;
        });

        if (!encontradoNumero) return false;
      }

      return true;
    });
    this.cdr.markForCheck();
  }

  // Método usado pelo template para resetar filtros e recarregar
  resetarERecarregar(): void {
    this.resetarFiltro();
    // após resetar, recarrega usando aplicarFiltro para garantir dados paginados
    this.aplicarFiltro();
  }

  private processarDadosServicos(response: any): void {
    // Se response.itens for um array de registros diretos (sem cadastros/recadastros aninhados)
    if (Array.isArray(response?.itens) && response.itens.length > 0 && !response.itens[0].cadastros && !response.itens[0].recadastros) {
      // Cada item já é um registro
      this.servicos = response.itens.map((item: any) => ({
        ...item,
        tipoServico: this.determinarTipoServico(item),
        id: item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000"
          ? item.recadastroId
          : item.cadastroId,
        dataServico: item.dataHoraInicio
      }));
      this.servicosFiltrados = this.servicos;
      return;
    }

    const primeiroItem = response?.itens?.[0];
    if (!primeiroItem) {
      this.servicos = [];
      this.servicosFiltrados = [];
      return;
    }
    const cadastros = primeiroItem.cadastros || [];
    const recadastros = primeiroItem.recadastros || [];
    let todosRegistros: any[] = [];
    // Processa cadastros
    const cadastrosComTipo = cadastros.map((item: any) => ({
      ...item,
      tipoServico: 'cadastro',
      id: item.cadastroId,
      dataServico: item.dataHoraInicio
    }));
    // Processa recadastros
    const recadastrosComTipo = recadastros.map((item: any) => ({
      ...item,
      tipoServico: 'recadastro',
      id: item.recadastroId,
      dataServico: item.dataHoraInicio 
    }));
    todosRegistros = [...cadastrosComTipo, ...recadastrosComTipo];
    const deveOrdenar = !(this.filtroDataInicio || this.filtroDataFim);
    if (this.tamanhoPagina > 0) {
      if (deveOrdenar) {
        this.servicos = todosRegistros
          .sort((a, b) => new Date(b.dataServico).getTime() - new Date(a.dataServico).getTime())
          .slice(0, this.tamanhoPagina);
      } else {
        this.servicos = todosRegistros.slice(0, this.tamanhoPagina);
      }
    } else {
      this.servicos = deveOrdenar
        ? [...todosRegistros].sort((a, b) => new Date(b.dataServico).getTime() - new Date(a.dataServico).getTime())
        : [...todosRegistros];
    }
    this.servicosFiltrados = this.servicos;
    this.cdr.markForCheck();
  }

  private processarDadosPaginados(response: any): void {
    // Se response.itens for um array de registros diretos (sem cadastros/recadastros aninhados)
    if (Array.isArray(response?.itens) && response.itens.length > 0 && !response.itens[0].cadastros && !response.itens[0].recadastros) {
      // Cada item já é um registro
      this.servicos = response.itens.map((item: any) => ({
        ...item,
        tipoServico: this.determinarTipoServico(item),
        id: item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000"
          ? item.recadastroId
          : item.cadastroId,
        dataServico: item.dataHoraInicio 
      }));
      this.servicosFiltrados = this.servicos;
      return;
    }

    // Para dados paginados, precisa acessar o primeiro item e depois os arrays internos
    const primeiroItem = response?.itens?.[0];

    if (!primeiroItem) {
      this.servicos = [];
      this.servicosFiltrados = [];
      return;
    }

    const cadastros = primeiroItem.cadastros || [];
    const recadastros = primeiroItem.recadastros || [];

    let todosRegistros: any[] = [];

    // Processa cadastros
    const cadastrosComTipo = cadastros.map((item: any) => ({
      ...item,
      tipoServico: 'cadastro',
      id: item.cadastroId,
      dataServico: item.dataHoraInicio
    }));

    // Processa recadastros
    const recadastrosComTipo = recadastros.map((item: any) => ({
      ...item,
      tipoServico: 'recadastro',
      id: item.recadastroId,
      dataServico: item.dataRecadastramento || item.dataRecadastro || item.dataHoraInicio
    }));

    todosRegistros = [...cadastrosComTipo, ...recadastrosComTipo];

    const deveOrdenar = !(this.filtroDataInicio || this.filtroDataFim);
    if (this.tamanhoPagina > 0) {
      if (deveOrdenar) {
        this.servicos = todosRegistros
          .sort((a, b) => new Date(b.dataServico).getTime() - new Date(a.dataServico).getTime())
          .slice(0, this.tamanhoPagina);
      } else {
        this.servicos = todosRegistros.slice(0, this.tamanhoPagina);
      }
    } else {
      this.servicos = deveOrdenar
        ? [...todosRegistros].sort((a, b) => new Date(b.dataServico).getTime() - new Date(a.dataServico).getTime())
        : [...todosRegistros];
    }
    this.servicosFiltrados = this.servicos;
    this.cdr.markForCheck();
  }

  private determinarTipoServico(item: any): string {
    if (item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000") {
      return 'recadastro';
    }
    return 'cadastro';
  }

  verDetalhes(registro: any): void {
    const isTV = this.deviceService.isTV();

    // 🔹 Caso seja TV, redireciona para o roteiro
    if (isTV) {
      const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
      
      // Determinar o ID correto (recadastroId ou cadastroId)
      let idParaBuscar = '';
      const isRecadastro = registro.tipoServico === 'recadastro';
      
      if (isRecadastro) {
        idParaBuscar = registro.recadastroId && registro.recadastroId !== ZERO_UUID 
          ? registro.recadastroId 
          : registro.id;
      } else {
        idParaBuscar = registro.cadastroId && registro.cadastroId !== ZERO_UUID 
          ? registro.cadastroId 
          : registro.id;
      }

      if (!idParaBuscar || idParaBuscar === ZERO_UUID) {
        console.warn('[TV] Nenhum ID válido encontrado para registro:', registro);
        return;
      }

      this.spinner.show();
      
      // Primeiro buscar detalhes para pegar dataHoraInicio e usuarioId
      const serviceCall = isRecadastro
        ? this.servicoService.obterRecadastroPorId(idParaBuscar)
        : this.servicoService.obterCadastroPorId(idParaBuscar);

      serviceCall.subscribe({
        next: (detalhes) => {
          const queryParams: any = {};
          
          // Adicionar usuarioId se disponível
          if (detalhes?.usuarioId) {
            queryParams.usuarioId = detalhes.usuarioId;
          }
          
          // Buscar idJuncao se disponível
          const idJuncao = detalhes?.idJuncao || detalhes?.IdJuncao || detalhes?.idjuncao || detalhes?.idJuncaoFk;
          
          if (idJuncao && idJuncao !== ZERO_UUID) {
            queryParams.idJuncao = idJuncao;
            
            // Buscar detalhes completos por idJuncao
            this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe({
              next: (detalhesCompletos) => {
                const dataEvento = detalhesCompletos?.dataHoraInicio || detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                
                if (detalhesCompletos?.recadastroId || detalhes?.recadastroId) {
                  queryParams.recadastroId = detalhesCompletos?.recadastroId || detalhes?.recadastroId;
                } else if (detalhesCompletos?.cadastroId || detalhes?.cadastroId) {
                  queryParams.cadastroId = detalhesCompletos?.cadastroId || detalhes?.cadastroId;
                }
                
                this.ngZone.run(() => {
                  this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                    .finally(() => this.spinner.hide());
                });
              },
              error: (err) => {
                console.error('[TV] Erro ao buscar detalhes por idJuncao', err);
                // Fallback: usar dados do primeiro fetch
                const dataEvento = detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (isRecadastro) {
                  queryParams.recadastroId = idParaBuscar;
                } else {
                  queryParams.cadastroId = idParaBuscar;
                }
                this.ngZone.run(() => {
                  this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                    .finally(() => this.spinner.hide());
                });
              }
            });
            return;
          }
          
          // Se não tem idJuncao, usar período da data do evento
          const dataEvento = detalhes?.dataHoraInicio;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          
          if (isRecadastro) {
            queryParams.recadastroId = idParaBuscar;
          } else {
            queryParams.cadastroId = idParaBuscar;
          }
          
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
              .finally(() => this.spinner.hide());
          });
        },
        error: (err) => {
          console.error('[TV] Erro ao buscar detalhes do cadastro/recadastro', err);
          this.spinner.hide();
          alert('Erro ao carregar detalhes para navegação.');
        }
      });
      return;
    }

    // 🔹 Caso NÃO seja TV, mantém comportamento normal (abrir modal)
    this.spinner.show();
    this.servicoDetalhes = null;

    const isRecadastro = registro.tipoServico === 'recadastro';
    const serviceCall = isRecadastro
      ? this.servicoService.obterRecadastroPorId(registro.recadastroId || registro.id)
      : this.servicoService.obterCadastroPorId(registro.cadastroId || registro.id);

    serviceCall.subscribe({
      next: (detalhes) => {
        this.spinner.hide();
        this.servicoDetalhes = detalhes;
        this.cdr.detectChanges();
        // Força um repaint para garantir que o modal apareça imediatamente
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 0);
        setTimeout(() => this.inicializarMapaServico(), 350);
      },
      error: () => {
        this.spinner.hide();
        alert('Erro ao buscar detalhes do registro.');
      }
    });
  }

  inicializarMapaServico(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapServico) {
      (window as any)._mapServico.remove();
      (window as any)._mapServico = null;
    }

    const latInicio = this.servicoDetalhes?.latitudeInicio;
    const lngInicio = this.servicoDetalhes?.longitudeInicio;
    const latFim = this.servicoDetalhes?.latitudeFim;
    const lngFim = this.servicoDetalhes?.longitudeFim;
    const divMapa = document.getElementById('map-servico');
    if (!divMapa) return;

    divMapa.innerHTML = '';
    divMapa.style.height = '220px';
    divMapa.style.width = '100%';

    // Só mostra o mapa se pelo menos um ponto existir
    if (latInicio && lngInicio || latFim && lngFim) {
      // Centro do mapa: se ambos, faz média, senão usa o que existir
      let centerLat = latInicio || latFim;
      let centerLng = lngInicio || lngFim;
      if (latInicio && lngInicio && latFim && lngFim) {
        centerLat = (Number(latInicio) + Number(latFim)) / 2;
        centerLng = (Number(lngInicio) + Number(lngFim)) / 2;
      }
      const map = L.map('map-servico').setView([centerLat, centerLng], 16);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(map);

      // Marcador início (azul)
      if (latInicio && lngInicio) {
        const inicioIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latInicio, lngInicio], { icon: inicioIcon }).addTo(map).bindPopup('Início da vistoria');
      }

      // Marcador fim (vermelho)
      if (latFim && lngFim) {
        const fimIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latFim, lngFim], { icon: fimIcon }).addTo(map).bindPopup('Fim da vistoria');
      }

      (window as any)._mapServico = map;
    } else {
      divMapa.innerHTML = '<div style="text-align:center;padding:40px 0;color:#888;">Sem coordenadas para exibir o mapa.</div>';
      divMapa.style.height = '120px';
    }
  }

  fecharModalDetalhes(): void {
    this.servicoDetalhes = null;
    this.cdr.markForCheck();
  }

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = url;
    this.mostrarModalFoto = true;
    // Busca a rotação salva (do objeto em memória ou localStorage)
    this.rotacaoFoto = this.getRotacaoMiniatura(url);
    this.cdr.markForCheck();
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
    this.rotacaoFoto = 0;
    this.cdr.markForCheck();
  }

  salvarRotacaoFoto(): void {
    if (!this.fotoSelecionada) return;
    const key = this.getFotoRotacaoKey(this.fotoSelecionada);
    localStorage.setItem(key, this.rotacaoFoto.toString());
  }

  excluirFoto(foto: any): void {
    if (!foto) return;
    const id = String(foto.fotoId || foto.id || foto.foto?.id || foto.fotoId || foto.idFoto || '');
    if (!id) {
      Swal.fire('Erro', 'Não foi possível identificar o ID da foto para exclusão.', 'error');
      return;
    }

    Swal.fire({
      title: 'Confirma exclusão desta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (!result.isConfirmed) return;
      Swal.fire({
        title: 'Excluindo...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
        showConfirmButton: false
      });
      this.formularioService.excluirFoto(id).subscribe({
        next: () => {
          try {
            const url = foto.url || foto.path || '';
            if (url) {
              const key = this.getFotoRotacaoKey(url);
              localStorage.removeItem(key);
            }
            this.servicoDetalhes.fotos = (this.servicoDetalhes.fotos || []).filter((f: any) => {
              const fid = String(f.fotoId || f.id || f.foto?.id || f.idFoto || '');
              return fid !== id;
            });
          } catch (e) { /* ignore */ }
          Swal.close();
          this.cdr.markForCheck();
          Swal.fire('Excluída', 'Foto excluída com sucesso.', 'success');
        },
        error: (err) => {
          console.error('Erro ao excluir foto:', err);
          Swal.close();
          Swal.fire('Erro', 'Erro ao excluir foto.', 'error');
          this.cdr.markForCheck();
        }
      });
    });
  }

  excluirFotoDocumento(fotoDoc: any): void {
    if (!fotoDoc) return;
    const id = String(fotoDoc.fotoDocumentoId || fotoDoc.id || fotoDoc.idDocumento || fotoDoc.foto?.id || '');
    if (!id) {
      Swal.fire('Erro', 'Não foi possível identificar o ID do documento para exclusão.', 'error');
      return;
    }

    Swal.fire({
      title: 'Confirma exclusão deste documento/foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (!result.isConfirmed) return;
      Swal.fire({
        title: 'Excluindo...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
        showConfirmButton: false
      });
      this.formularioService.excluirFotosDocumento(id).subscribe({
        next: () => {
          try {
            const url = fotoDoc.url || fotoDoc.path || '';
            if (url) {
              const key = this.getFotoRotacaoKey(url);
              localStorage.removeItem(key);
            }
            this.servicoDetalhes.fotosDocumento = (this.servicoDetalhes.fotosDocumento || []).filter((d: any) => {
              const did = String(d.fotoDocumentoId || d.id || d.idDocumento || d.foto?.id || '');
              return did !== id;
            });
          } catch (e) { /* ignore */ }
          Swal.close();
          this.cdr.markForCheck();
          Swal.fire('Excluído', 'Documento excluído com sucesso.', 'success');
        },
        error: (err) => {
          console.error('Erro ao excluir documento:', err);
          Swal.close();
          Swal.fire('Erro', 'Erro ao excluir documento.', 'error');
          this.cdr.markForCheck();
        }
      });
    });
  }

  getFotoRotacaoKey(url: string): string {
    // Usa a URL como chave única
    return 'foto_rotacao_' + btoa(encodeURIComponent(url));
  }

  girarFoto(direcao: 'esquerda' | 'direita'): void {
    if (direcao === 'esquerda') {
      this.rotacaoFoto -= 90;
    } else {
      this.rotacaoFoto += 90;
    }
    this.rotacaoFoto = ((this.rotacaoFoto % 360) + 360) % 360;
    
    // Salva automaticamente a rotação no localStorage e no objeto
    if (this.fotoSelecionada) {
      const key = this.getFotoRotacaoKey(this.fotoSelecionada);
      this.rotacoesMiniatura[key] = this.rotacaoFoto;
      localStorage.setItem(key, this.rotacaoFoto.toString());
    }
  }

  private async buscarTodosRegistros(
    status: string,
    statusOS: string,
    dataInicio?: string,
    dataFim?: string,
    porUsuario: boolean = false
  ): Promise<{ registros: any[]; total: number }> {
    const lote = this.TODOS_PAGE_SIZE;
    const registrosAcumulados: any[] = [];
    let pagina = 1;
    let totalEsperado = 0;

    if (porUsuario && !this.filtroUsuarioId) {
      return { registros: [], total: 0 };
    }

    while (true) {
      const response = porUsuario
        ? await firstValueFrom(
            this.servicoService.obterTodosRegistrosPorPeriodo(
              this.filtroUsuarioId,
              dataInicio,
              dataFim,
              pagina,
              lote,
              status || undefined,
              this.filtroNomeConsumidor || undefined,
              this.filtroCpf || undefined,
              this.filtroCnpj || undefined,
              this.filtroMatricula || undefined,
              this.filtroCep || undefined,
              this.filtroLogradouro || undefined,
              this.filtroBairro || undefined,
              this.filtroCidade || undefined,
              this.filtroNumero || undefined,
              this.filtroEstado || undefined,
              statusOS || undefined
            )
          )
        : await firstValueFrom(
            this.servicoService.obterTodos(
              dataInicio,
              dataFim,
              pagina,
              lote,
              status || undefined,
              this.filtroNomeConsumidor || undefined,
              this.filtroCpf || undefined,
              this.filtroCnpj || undefined,
              this.filtroMatricula || undefined,
              this.filtroCep || undefined,
              this.filtroLogradouro || undefined,
              this.filtroBairro || undefined,
              this.filtroCidade || undefined,
              this.filtroEstado || undefined,
              this.filtroNumero || undefined,
              undefined,
              statusOS || undefined
            )
          );

      if (pagina === 1) {
        totalEsperado = this.obterTotalRegistros(response);
      }

      const registrosPagina = this.extrairRegistrosDaResposta(response);
      if (registrosPagina.length === 0) {
        break;
      }

      registrosAcumulados.push(...registrosPagina);

      if (totalEsperado > 0 && registrosAcumulados.length >= totalEsperado) {
        break;
      }

      if (totalEsperado === 0 && registrosPagina.length < lote) {
        break;
      }

      pagina++;

      if (totalEsperado === 0 && pagina > 50) {
        break;
      }
    }

    return {
      registros: registrosAcumulados,
      total: totalEsperado || registrosAcumulados.length
    };
  }

  private extrairRegistrosDaResposta(response: any): any[] {
    if (!response) {
      return [];
    }
    const itens = response?.itens;
    if (!Array.isArray(itens) || itens.length === 0) {
      return [];
    }

    if (!itens[0].cadastros && !itens[0].recadastros) {
      return itens.map((item: any) => ({
        ...item,
        tipoServico: this.determinarTipoServico(item),
        id:
          item.recadastroId && item.recadastroId !== '00000000-0000-0000-0000-000000000000'
            ? item.recadastroId
            : item.cadastroId,
        dataServico: item.dataHoraInicio
      }));
    }

    const primeiroItem = itens[0];
    const cadastros = primeiroItem?.cadastros || [];
    const recadastros = primeiroItem?.recadastros || [];

    const cadastrosComTipo = cadastros.map((item: any) => ({
      ...item,
      tipoServico: 'cadastro',
      id: item.cadastroId,
      dataServico: item.dataHoraInicio
    }));

    const recadastrosComTipo = recadastros.map((item: any) => ({
      ...item,
      tipoServico: 'recadastro',
      id: item.recadastroId,
      dataServico: item.dataRecadastramento || item.dataRecadastro || item.dataHoraInicio
    }));

    return [...cadastrosComTipo, ...recadastrosComTipo];
  }

  private obterTotalRegistros(response: any): number {
    const primeiroItem = response?.itens?.[0];
    if (primeiroItem && primeiroItem.totalGeral !== undefined && primeiroItem.totalGeral !== null) {
      const valor = Number(primeiroItem.totalGeral);
      return isNaN(valor) ? 0 : valor;
    }
    if (response?.totalItens !== undefined && response?.totalItens !== null) {
      const valor = Number(response.totalItens);
      return isNaN(valor) ? 0 : valor;
    }
    if (Array.isArray(response?.itens)) {
      return response.itens.length;
    }
    return 0;
  }

  private prepararRegistrosParaApresentacao(registros: any[], total: number): void {
    const deveOrdenar = !(this.filtroDataInicio || this.filtroDataFim);
    const lista = deveOrdenar
      ? [...registros].sort((a: any, b: any) => {
          const dataA = new Date(a.dataServico || a.dataHoraInicio || a.dataRecadastro || a.data);
          const dataB = new Date(b.dataServico || b.dataHoraInicio || b.dataRecadastro || b.data);
          return dataB.getTime() - dataA.getTime();
        })
      : [...registros];

    this.servicos = lista;
    this.servicosFiltrados = [...lista];
    this.totalItens = total > 0 ? total : lista.length;
    this.totalPaginas = 1;
    this.paginaAtual = 1;
    this.mostrarTodosRegistros = true;
    this.cdr.markForCheck();
  }

  exportarServicoParaPDF(): void {
    if (!this.servicoDetalhes) return;

    // Salva os dados do serviço antes de fechar o modal
    const dadosServico = { ...this.servicoDetalhes };

    // Busca o modal-body original
    const modalBodyOriginal = document.querySelector('.modal-body') as HTMLElement;
    if (!modalBodyOriginal) return;

    // Cria um clone do modal-body para captura
    const modalBodyClone = modalBodyOriginal.cloneNode(true) as HTMLElement;

    // Configura o clone para captura completa mas visível para html2canvas
    modalBodyClone.style.position = 'absolute';
    modalBodyClone.style.top = '-9999px';
    modalBodyClone.style.left = '-9999px';
    modalBodyClone.style.overflow = 'visible';
    modalBodyClone.style.maxHeight = 'none';
    modalBodyClone.style.height = 'auto';
    modalBodyClone.style.width = modalBodyOriginal.offsetWidth + 'px';
    modalBodyClone.style.visibility = 'visible';
    modalBodyClone.style.pointerEvents = 'none';
    modalBodyClone.style.opacity = '1';

    // Adiciona o clone ao body temporariamente
    document.body.appendChild(modalBodyClone);

    // Fecha o modal imediatamente para melhor UX
    this.fecharModalDetalhes();

    // Usa requestIdleCallback para não travar a UI durante a geração do PDF
    requestIdleCallback(() => {
      html2canvas(modalBodyClone, {
        scale: 2, // Aumenta a escala para melhor qualidade
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        logging: false, // Desabilita logging para performance
        width: modalBodyClone.scrollWidth,
        height: modalBodyClone.scrollHeight
      }).then((canvas: HTMLCanvasElement) => {
        // Remove o clone após a captura
        document.body.removeChild(modalBodyClone);


        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = 210;
        const pdfHeight = 297;
        const margin = 1;
        const contentWidth = pdfWidth - (margin * 2);
        const pageContentHeight = pdfHeight - (margin * 2);

        // Proporção da imagem para o PDF
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * contentWidth) / canvas.width;

        // Altura do canvas em pixels correspondente a uma página PDF
        const pageHeightPx = Math.floor((pageContentHeight * canvas.height) / imgHeight);
        const minRestPx = 100; // altura mínima para não cortar elemento grande
        let renderedHeight = 0;
        let pageNum = 1;

        while (renderedHeight < canvas.height) {
          let pageCanvasHeight = Math.min(pageHeightPx, canvas.height - renderedHeight);
          // Se o restante do canvas for menor que minRestPx, pule para próxima página
          if (canvas.height - (renderedHeight + pageCanvasHeight) < minRestPx && (canvas.height - renderedHeight) > pageHeightPx) {
            pageCanvasHeight = canvas.height - renderedHeight - minRestPx;
          }

          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pageCanvasHeight;

          // Copia a parte do canvas para a página
          pageCtx?.drawImage(
            canvas,
            0, renderedHeight, canvas.width, pageCanvasHeight,
            0, 0, canvas.width, pageCanvasHeight
          );

          const pageImgData = pageCanvas.toDataURL('image/png');
          const pageImgHeight = (pageCanvasHeight * imgWidth) / canvas.width;

          if (pageNum > 1) pdf.addPage();
          pdf.addImage(pageImgData, 'PNG', margin, margin, imgWidth, pageImgHeight);

          renderedHeight += pageCanvasHeight;
          pageNum++;
        }

        // Usa os dados salvos para o nome do arquivo
        const nome = dadosServico?.nomeConsumidor?.replace(/\s/g, '_') || 'servico';
        pdf.save(`${nome}_servico.pdf`);
      }).catch((error: any) => {
        console.error('Erro ao gerar PDF:', error, error?.message, error?.stack);
        // Remove o clone em caso de erro
        if (document.body.contains(modalBodyClone)) {
          document.body.removeChild(modalBodyClone);
        }
        alert('Erro ao gerar o PDF. Tente novamente.');
      });
    });
  }

  /**
   * Exporta os dados filtrados da tabela para Excel
   * Com título "Relatório de Vistorias" e logos
   * Busca TODOS os registros do período atual, não apenas a página atual
   */
  async exportarParaExcel(): Promise<void> {
    try {
      this.spinner.show();

      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

      // Para "Validado" ou "Invalido", envia como Status; para os demais, como StatusOS
      let status = '';
      let statusOS = '';
      if (this.filtroStatus === 'Validado' || this.filtroStatus === 'Invalido') {
        status = this.filtroStatus;
      } else if (this.filtroStatus) {
        statusOS = this.filtroStatus;
      }

      const { registros: registrosCompletos } = await this.buscarTodosRegistros(
        status,
        statusOS,
        dataInicio,
        dataFim,
        !!this.filtroUsuarioId
      );

      const todosRegistros = (this.filtroDataInicio || this.filtroDataFim)
        ? [...registrosCompletos]
        : [...registrosCompletos].sort((a: any, b: any) => {
            const dataA = new Date(a.dataServico || a.dataHoraInicio || a.dataRecadastro || a.data);
            const dataB = new Date(b.dataServico || b.dataHoraInicio || b.dataRecadastro || b.data);
            return dataB.getTime() - dataA.getTime();
          });

      // Se não houver registros, mostra mensagem e cancela
      if (todosRegistros.length === 0) {
        this.spinner.hide();
        alert('Nenhum registro encontrado para exportar.');
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Relatório');

      // Função auxiliar para baixar imagem e converter para base64
      const getImageBase64 = async (url: string): Promise<string | null> => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64 = reader.result as string;
              resolve(base64.split(',')[1]);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error('Erro ao carregar imagem:', url, error);
          return null;
        }
      };

      // Baixa as imagens dos logos
      const [logoCedaeBase64, logoVibetexBase64] = await Promise.all([
        getImageBase64('https://cedae.vibetex.com.br/images/cedae2.jpg'),
        getImageBase64('https://cedae.vibetex.com.br/images/logo_vibetex.png')
      ]);

      let imagemCedaeId: number | null = null;
      let imagemVibetexId: number | null = null;

      if (logoCedaeBase64) {
        imagemCedaeId = workbook.addImage({
          base64: logoCedaeBase64,
          extension: 'jpeg',
        });
      }

      if (logoVibetexBase64) {
        imagemVibetexId = workbook.addImage({
          base64: logoVibetexBase64,
          extension: 'png',
        });
      }

      // Linha 1: Título
      worksheet.mergeCells('C1:K1');
      const titleCell = worksheet.getCell('C1');
      titleCell.value = 'Relatório de Vistorias - Auditoria de Campo';
      titleCell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
      titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
      titleCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0062CC' }
      };
      worksheet.getRow(1).height = 50;

      if (imagemVibetexId !== null) {
        worksheet.addImage(imagemVibetexId, {
          tl: { col: 2.1, row: 0.1 },
          ext: { width: 60, height: 55 }
        });
      }

      if (imagemCedaeId !== null) {
        worksheet.addImage(imagemCedaeId, {
          tl: { col: 10.3, row: 0.1 },
          ext: { width: 55, height: 55 }
        });
      }

      worksheet.addRow([]);

      worksheet.mergeCells('C3:K3');
      const cadastroRow = worksheet.getRow(3);
      cadastroRow.getCell('C').value = 'Cadastro / Recadastro';
      cadastroRow.getCell('C').font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
      cadastroRow.getCell('C').alignment = { vertical: 'middle', horizontal: 'center' };
      cadastroRow.getCell('C').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0062CC' }
      };
      cadastroRow.height = 20;

      worksheet.addRow([]);

      worksheet.getColumn(1).width = 3;
      worksheet.getColumn(2).width = 3;
      worksheet.getColumn(3).width = 6;   // #
      worksheet.getColumn(4).width = 30;  // ENDEREÇO
      worksheet.getColumn(5).width = 8;   // Nº
      worksheet.getColumn(6).width = 25;  // MUNICÍPIO
      worksheet.getColumn(7).width = 23;  // BAIRRO
      worksheet.getColumn(8).width = 19;  // SERVIÇO EXECUTADO
      worksheet.getColumn(9).width = 15;  // Nº VISTORIA
      worksheet.getColumn(10).width = 12; // DATA
      worksheet.getColumn(11).width = 12; // STATUS

      const headerRow = worksheet.getRow(5);
      headerRow.values = ['', '', '#', 'ENDEREÇO', 'Nº', 'MUNICÍPIO', 'BAIRRO', 'SERVIÇO EXECUTADO', 'Nº VISTORIA', 'DATA', 'STATUS'];
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.height = 25;

      for (let col = 3; col <= 11; col++) {
        headerRow.getCell(col).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF0062CC' }
        };
      }

      todosRegistros.forEach((servico, index) => {
        let logradouroTipo = '';
        let logradouroNome = '';
        let enderecoCompleto = '';
        let numero = '';
        let municipio = '';
        let bairro = '';

        if (servico.endereco) {
          logradouroTipo = servico.endereco.logradouroTipo ||
            servico.endereco.tipoLogradouro ||
            servico.endereco.tipo ||
            servico.endereco.tipoEndereco || '';

          logradouroNome = servico.endereco.logradouro ||
            servico.endereco.nomeLogradouro ||
            servico.endereco.nome ||
            servico.endereco.rua || '';

          numero = servico.endereco.numero ||
            servico.endereco.numeroEndereco ||
            servico.endereco.numeroLogradouro || '';

          municipio = servico.endereco.municipio ||
            servico.endereco.cidade ||
            servico.endereco.localidade ||
            servico.endereco.nomeMunicipio || '';

          bairro = servico.endereco.bairro ||
            servico.endereco.nomeBairro || '';
        }

        // Fallback: tenta campos diretos no objeto principal
        if (!logradouroTipo) {
          logradouroTipo = servico.logradouroTipo ||
            servico.tipoLogradouro ||
            servico.tipo || '';
        }

        if (!logradouroNome) {
          logradouroNome = servico.logradouro ||
            servico.nomeLogradouro ||
            servico.rua || '';
        }

        if (!numero) {
          numero = servico.numero ||
            servico.numeroEndereco ||
            servico.numeroLogradouro || '';
        }

        if (!municipio) {
          municipio = servico.municipio ||
            servico.cidade ||
            servico.localidade ||
            servico.nomeMunicipio || '';
        }

        if (!bairro) {
          bairro = servico.bairro ||
            servico.nomeBairro || '';
        }

        // Monta o endereço completo
        enderecoCompleto = logradouroTipo && logradouroNome
          ? `${logradouroTipo} ${logradouroNome}`.trim()
          : logradouroNome || logradouroTipo || '';

        // Se não encontrou tipo de logradouro separado, tenta extrair do endereço completo
        if (!logradouroTipo && enderecoCompleto) {
          const tiposLogradouro = ['Rua', 'Avenida', 'Av', 'Travessa', 'Trav', 'Alameda', 'Praça',
            'Rodovia', 'Estrada', 'Largo', 'Viela', 'Beco', 'Conjunto'];

          for (const tipo of tiposLogradouro) {
            const regex = new RegExp(`^${tipo}\\s`, 'i');
            if (regex.test(enderecoCompleto)) {
              logradouroTipo = tipo;
              break;
            }
          }
        }

        // Se ainda não tem endereço completo, usa o método getEnderecoCompleto
        if (!enderecoCompleto) {
          enderecoCompleto = this.getEnderecoCompleto(servico);

          // Tenta extrair tipo novamente do endereço obtido
          if (!logradouroTipo && enderecoCompleto && enderecoCompleto !== '-') {
            const tiposLogradouro = ['Rua', 'Avenida', 'Av', 'Travessa', 'Trav', 'Alameda', 'Praça',
              'Rodovia', 'Estrada', 'Largo', 'Viela', 'Beco', 'Conjunto'];

            for (const tipo of tiposLogradouro) {
              const regex = new RegExp(`^${tipo}\\s`, 'i');
              if (regex.test(enderecoCompleto)) {
                logradouroTipo = tipo;
                break;
              }
            }
          }
        }

        let dataFormatada = '';
        const candidatoDataStr = servico.dataServico || servico.dataRecadastramento || servico.dataCadastroOriginal || servico.dataCadastro || servico.dataHoraInicio || servico.dataCriacao || servico.data;
        if (candidatoDataStr) {
          const data = new Date(candidatoDataStr);
          if (!isNaN(data.getTime())) {
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            dataFormatada = `${dia}/${mes}/${ano}`;
          } else {
            if (typeof candidatoDataStr === 'string') {
              const m = candidatoDataStr.match(/(\d{4})-(\d{2})-(\d{2})/);
              if (m) {
                dataFormatada = `${m[3]}/${m[2]}/${m[1]}`;
              }
            }
          }
        }

        // Determina o tipo de serviço (Cadastro ou Recadastro)
        const tipoServico = this.determinarTipoServico(servico);
        const tipo = tipoServico === 'recadastro' ? 'Recadastro' : 'Cadastro';
        const numeroVistoria = this.formatNumeroOS(servico);

        // Define status dinamicamente
        const statusTexto = this.effectiveStatus(servico);
        
        // Define cores baseadas no status
        let corStatus = 'FF28A745'; // Verde padrão
        if (statusTexto === 'Negado' || statusTexto === 'Negada') {
          corStatus = 'FFDC3545'; // Vermelho
        } else if (statusTexto === 'Pendente' || statusTexto === 'EmAndamento') {
          corStatus = 'FFFFB703'; // Amarelo
        } else if (statusTexto === 'Invalido') {
          corStatus = 'FFDC3545'; // Vermelho
        } else if (statusTexto === 'Validado' || statusTexto === 'Concluido' || statusTexto === 'Concluída') {
          corStatus = 'FF28A745'; // Verde
        } else if (statusTexto === 'Retornar') {
          corStatus = 'FFF6B21A'; // Laranja
        } else if (statusTexto === 'Ausente') {
          corStatus = 'FF6C757D'; // Cinza
        } else if (statusTexto === 'Analisando') {
          corStatus = 'FF0D6EFD'; // Azul
        } else if (statusTexto === 'Cancelada') {
          corStatus = 'FF8A5A5A'; // Marrom
        }

        // Define cor do tipo de serviço (Cadastro ou Recadastro)
        const corTipo = tipo === 'Recadastro' ? 'FFE1BEE7' : 'FFB2EBF2';
        const corTextoTipo = 'FF000000';

        const row = worksheet.addRow([
          '', '', index + 1, enderecoCompleto || '-',
          numero || '-', municipio || '-', bairro || '-', tipo,
          numeroVistoria, dataFormatada || '-', statusTexto
        ]);

        // Aplica cor do tipo de serviço (coluna 8 - SERVIÇO EXECUTADO)
        row.getCell(8).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: corTipo }
        };
        row.getCell(8).font = {
          color: { argb: corTextoTipo },
          bold: true
        };
        row.getCell(8).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };

        // Aplica cor do status dinamicamente (coluna 11)
        row.getCell(11).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: corStatus }
        };
        row.getCell(11).font = {
          color: { argb: 'FFFFFFFF' },
          bold: true
        };
        row.getCell(11).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      });

      const primeiraLinhaDados = 6;
      const ultimaLinhaDados = 5 + todosRegistros.length;

      // Não aplica mais formatação condicional para coluna de Conformidade (removida)

      // Aplica bordas
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          if (colNumber >= 3 && colNumber <= 11) {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };

            if (rowNumber > 4) {
              if (colNumber === 3) {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFF8F9FA' }
                };
                cell.font = { bold: true };
              } else if (colNumber === 4) {
                cell.alignment = { vertical: 'middle', horizontal: 'left' };
              } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
              }
            }
          }
        });
      });

      // Estatísticas baseadas em TODOS os registros
      const totalRegistros = todosRegistros.length;

      worksheet.addRow([]);

      const rowTotal = worksheet.addRow(['', '', `TOTAL GERAL: ${totalRegistros}`, '', '', '', '', '', '', '', '']);
      rowTotal.font = { bold: true, size: 11 };
      for (let col = 3; col <= 11; col++) {
        rowTotal.getCell(col).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE8F4F8' }
        };
      }
      worksheet.mergeCells(`C${rowTotal.number}:K${rowTotal.number}`);
      const cellRowTotal = rowTotal.getCell('C');
      cellRowTotal.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      rowTotal.height = 22;

      worksheet.addRow([]);

      let dataInicioFormatada = 'N/A';
      let dataFimFormatada = 'N/A';

      if (this.filtroDataInicio) {
        const [ano, mes, dia] = this.filtroDataInicio.split('-');
        dataInicioFormatada = `${dia}/${mes}/${ano}`;
      }

      if (this.filtroDataFim) {
        const [ano, mes, dia] = this.filtroDataFim.split('-');
        dataFimFormatada = `${dia}/${mes}/${ano}`;
      }

      const rowPeriodo = worksheet.addRow(['', '', `Período: ${dataInicioFormatada} até ${dataFimFormatada}`, '', '', '', '', '', '', '', '']);

      worksheet.mergeCells(`C${rowPeriodo.number}:K${rowPeriodo.number}`);

      const cellPeriodo = rowPeriodo.getCell('C');
      cellPeriodo.font = {
        bold: true,
        size: 11,
        color: { argb: 'FF0062CC' }
      };
      cellPeriodo.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      };
      cellPeriodo.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE8F4F8' }
      };
      cellPeriodo.border = {
        top: { style: 'thin', color: { argb: 'FF0062CC' } },
        left: { style: 'thin', color: { argb: 'FF0062CC' } },
        bottom: { style: 'thin', color: { argb: 'FF0062CC' } },
        right: { style: 'thin', color: { argb: 'FF0062CC' } }
      };

      rowPeriodo.height = 25;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const hoje = new Date();
      const dataArquivo = `${String(hoje.getDate()).padStart(2, '0')}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${hoje.getFullYear()}`;

      const nomeArquivo = `relatorio-vistorias-todas_${dataArquivo}.xlsx`;

      saveAs(blob, nomeArquivo);

      this.spinner.hide();
    } catch (error) {
      console.error('Erro ao exportar para Excel:', error);
      this.spinner.hide();
      alert('Erro ao exportar para Excel. Tente novamente.');
    }
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    // Use inclusive last 7 days: today and the 6 previous days -> subtract 7 to get start date 7 days ago
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  maskCpf(cpf: string): string {
    if (!cpf) return '-';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '-';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '-';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }

  getTipoServico(registro: any): string {
    return this.determinarTipoServico(registro);
  }

  effectiveStatus(servico: any): string {
    if (!servico) return '';
    const statusRaw = (servico.status || '').toString();
    const status = statusRaw.toLowerCase();
    const statusOS = (servico.statusOS || servico.statusOs || servico.status_os || '').toString();

    // Se status indica um dos casos em que devemos priorizar o próprio status:
    if (['analisando', 'validado', 'invalido'].includes(status)) {
      return statusRaw;
    }

    if (statusOS) return statusOS;

    return statusRaw || '';
  }

  statusKey(servico: any): string {
    const s = (this.effectiveStatus(servico) || '').toString();
    return s.toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/g, '');
  }

  statusClasses(servico: any): { [klass: string]: boolean } {
    const key = this.statusKey(servico);
    const eff = (this.effectiveStatus(servico) || '').toLowerCase();

    return {
      // 'Concluida' usa um ícone (check circle) diferente do 'Validado'
      'bi-check-circle-fill status-concluida': key === 'concluida',
      // 'Cancelada' - exibe um X dentro de um círculo e uma classe visual específica
      'bi-x-circle-fill status-cancelada text-secondary': key === 'cancelada' || eff === 'cancelada' || key === 'cancelado' || eff === 'cancelado',
      'bi-patch-check-fill status-validado': eff === 'validado',
      'bi-x-octagon-fill status-negado text-danger': key === 'negada' || eff === 'negado',
      'bi-play-circle-fill status-pendente': key === 'emandamento' || eff === 'pendente' || key === 'emandamento',
      'bi-arrow-counterclockwise status-retornar text-warning': key === 'retornar',
      'bi-exclamation-triangle-fill status-invalido': eff === 'invalido',
      'bi-dash-circle-fill status-ausente text-muted': eff === 'ausente',
      'bi-question-circle-fill text-muted': !eff || (!['validado', 'pendente', 'invalido', 'negado', 'ausente', 'analisando'].includes(eff) && !['concluida', 'negada', 'emandamento', 'retornar'].includes(key)),
      'bi-hourglass-split status-analisando': eff === 'analisando'
    };
  }

  getEnderecoCompleto(servico: any): string {
    // Se tem objeto endereco, usa ele
    if (servico.endereco) {
      const endereco = servico.endereco;
      let enderecoCompleto = '';

      if (endereco.logradouro) {
        enderecoCompleto += endereco.logradouro;
      }

      if (endereco.numero) {
        enderecoCompleto += (enderecoCompleto ? ', ' : '') + endereco.numero;
      }

      if (endereco.bairro) {
        enderecoCompleto += (enderecoCompleto ? ' - ' : '') + endereco.bairro;
      }

      // Tenta cidade, localidade ou municipio
      const cidade = endereco.cidade || endereco.localidade || endereco.municipio;
      if (cidade) {
        enderecoCompleto += (enderecoCompleto ? ', ' : '') + cidade;
      }

      return enderecoCompleto || '-';
    }

    // Fallback para campos diretos (caso antigo)
    if (servico.logradouro) {
      let endereco = servico.logradouro;
      if (servico.numero) endereco += ', ' + servico.numero;
      if (servico.bairro) endereco += ' - ' + servico.bairro;
      // Tenta cidade, localidade ou municipio
      const cidade = servico.cidade || servico.localidade || servico.municipio;
      if (cidade) endereco += ', ' + cidade;
      return endereco;
    }
    return '-';
  }

  private atualizarInformacoesPaginacao(response: any): void {
    // Para o novo formato, o total está no totalGeral do primeiro item
    const primeiroItem = response?.itens?.[0];

    if (primeiroItem && primeiroItem.totalGeral !== undefined) {
      this.totalItens = primeiroItem.totalGeral;
      this.paginaAtual = response.paginaAtual || 1;
      this.totalPaginas = this.tamanhoPagina > 0 && this.totalItens > 0
        ? Math.max(1, Math.ceil(this.totalItens / this.tamanhoPagina))
        : 1;
      // Persist paginaAtual and tamanhoPagina
      try { localStorage.setItem(this.LS_KEY_PAGINA, String(this.paginaAtual)); } catch (e) { /* ignore */ }
      try { localStorage.setItem(this.LS_KEY_TAMANHO, String(this.tamanhoPagina)); } catch (e) { /* ignore */ }
    } else if (response.totalItens !== undefined) {
      // Formato antigo
      this.totalItens = response.totalItens || 0;
      this.paginaAtual = response.paginaAtual || 1;
      this.totalPaginas = this.tamanhoPagina > 0 && this.totalItens > 0
        ? Math.max(1, Math.ceil(this.totalItens / this.tamanhoPagina))
        : 1;
      // Persist paginaAtual and tamanhoPagina
      try { localStorage.setItem(this.LS_KEY_PAGINA, String(this.paginaAtual)); } catch (e) { /* ignore */ }
      try { localStorage.setItem(this.LS_KEY_TAMANHO, String(this.tamanhoPagina)); } catch (e) { /* ignore */ }
    } else {
      // Para resposta não paginada
      this.totalItens = this.servicos.length;
      this.totalPaginas = 1;
      this.paginaAtual = 1;
    }
  }

  // Métodos para calcular o range de itens exibidos
  getItemInicio(): number {
    if (this.servicosFiltrados.length === 0) return 0;
    if (this.tamanhoPagina === -1) return 1;
    return ((this.paginaAtual - 1) * this.tamanhoPagina) + 1;
  }

  getItemFim(): number {
    if (this.servicosFiltrados.length === 0) return 0;
    if (this.tamanhoPagina === -1) return this.servicosFiltrados.length;
    return Math.min(this.paginaAtual * this.tamanhoPagina, this.totalItens);
  }

  // Métodos de navegação da paginação
  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      this.cdr.markForCheck();
      try { localStorage.setItem(this.LS_KEY_PAGINA, String(this.paginaAtual)); } catch (e) { /* ignore */ }
      this.carregarPagina();
    }
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      this.cdr.markForCheck();
      try { localStorage.setItem(this.LS_KEY_PAGINA, String(this.paginaAtual)); } catch (e) { /* ignore */ }
      this.carregarPagina();
    }
  }

  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      this.cdr.markForCheck();
      try { localStorage.setItem(this.LS_KEY_PAGINA, String(this.paginaAtual)); } catch (e) { /* ignore */ }
      this.carregarPagina();
    }
  }

  alterarTamanhoPagina(novoTamanho: number): void {
    const tamanho = Number(novoTamanho);
    if (!isNaN(tamanho) && tamanho === -1) {
      this.mostrarTodosRegistros = true;
      this.tamanhoPagina = -1;
    } else {
      this.mostrarTodosRegistros = false;
      this.tamanhoPagina = !isNaN(tamanho) && tamanho > 0 ? tamanho : 50;
    }
    this.paginaAtual = 1; // Reset para primeira página
    this.cdr.markForCheck();
    try { localStorage.setItem(this.LS_KEY_TAMANHO, String(this.tamanhoPagina)); } catch (e) { /* ignore */ }
    try { localStorage.setItem(this.LS_KEY_PAGINA, String(this.paginaAtual)); } catch (e) { /* ignore */ }
    this.aplicarFiltro(); // Reaplica o filtro com novo tamanho de página
  }

  private carregarPagina(): void {
    if (this.tamanhoPagina === -1) {
      return;
    }
    // Só recarrega se estivermos usando o filtro "Todos" (paginado)
    if (!this.filtroUsuarioId) {
      this.spinner.show();
      const dataInicio = this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00' : undefined;
      const dataFim = this.filtroDataFim ? this.filtroDataFim + 'T23:59:59' : undefined;

      // Passa todos os filtros atuais, igual ao aplicarFiltro
      // Usar a mesma lógica do aplicarFiltro para diferenciar status e statusOS
      let status = '';
      let statusOS = '';
      if (this.filtroStatus === 'Validado' || this.filtroStatus === 'Invalido') {
        status = this.filtroStatus;
      } else {
        statusOS = this.filtroStatus;
      }

      this.servicoService.obterTodos(
        dataInicio,
        dataFim,
        this.paginaAtual,
        this.tamanhoPagina,
        status,
        this.filtroNomeConsumidor,
        this.filtroCpf,
        this.filtroCnpj,
        this.filtroMatricula,
        this.filtroCep,
        this.filtroLogradouro,
        this.filtroBairro,
        this.filtroCidade,
        this.filtroEstado,
        this.filtroNumero,
        undefined, // numeroOS
        statusOS
      ).subscribe({
        next: (response) => {
          // Processa apenas os dados da página atual (sem reordenação)
          this.processarDadosPaginados(response);
          this.atualizarInformacoesPaginacao(response);
          this.aplicarFiltrosLocais();
          this.spinner.hide();
        },
        error: (err) => {
          this.erro = 'Erro ao carregar página.';
          this.spinner.hide();
        }
      });
    }
  }

  // Método para gerar array de páginas para o paginador
  obterPaginas(): number[] {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    const metade = Math.floor(maxPaginasVisiveis / 2);

    let inicio = Math.max(1, this.paginaAtual - metade);
    let fim = Math.min(this.totalPaginas, inicio + maxPaginasVisiveis - 1);

    // Ajusta o início se estivermos próximos do fim
    if (fim - inicio < maxPaginasVisiveis - 1) {
      inicio = Math.max(1, fim - maxPaginasVisiveis + 1);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return paginas;
  }

}
